import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { adminHttp } from "~/Admin/services/http";
import Pagination from "react-js-pagination";
import Moment from "react-moment";
import { ChevronRight } from "~/Components/Icons/Icons";

const AdminHosts = ({ match, event, ...props }) => {

    const [response, setResponse] = useState({});

    const loadData = (page = 1) => {
        adminHttp
            .get('/events/' + event.id + '/hosts?page=' + page,)
            .then(res => {
                setResponse(res.data);
            });
    };

    useEffect(loadData, [event]);

    return (
        <div className="card shadow-sm bg-white mt-3">
            <div className="card-body">
                <table className="table">

                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Uploads</th>
                            <th scope="col">Last Active</th>
                            <th></th>
                        </tr>
                    </thead>


                    <tbody>
                        {response.data?.map((host) => (
                            <tr key={host.id}>
                                <th scope="row">{host.id}</th>
                                <td>{host.host.first_name} {host.host.last_name}</td>
                                <td>{host.host.email}</td>
                                <td>{host.uploads_count}</td>
                                <td><Moment format="DD/MM/YYYY h:mm:ss a" date={host.last_active} /></td>
                                <td>
                                    <Link to={"/guests/hosts/" + host.id}>
                                        <ChevronRight />
                                    </Link>
                                </td>
                            </tr>
                        ))}
                    </tbody>

                </table>
                {response.per_page < response.total && (
                    <Pagination
                        activePage={response.current_page}
                        itemsCountPerPage={response.per_page}
                        totalItemsCount={response.total}
                        pageRangeDisplayed={5}
                        itemClass="page-item"
                        linkClass="page-link"
                        onChange={loadData}
                    />
                )}
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminHosts);
